export default "__VITE_ASSET__CMuv_tD1__"